module.exports = __webpack_public_path__ + "img/E280.1bb9aaad.svg";